// Signed-in pages outside a role area (/choose-role; FR-031; routes.md). Only a web user who holds
// both served roles may stay; anyone else goes to their landing (signed out → /welcome). Main bundle:
// no school-admin code is imported here.
import { type Href, Redirect, Slot } from "expo-router";

import { landingHref, resolveLanding } from "@/session/access";
import { useSession } from "@/session/hooks";
import { usePlatform } from "@/session/platform";
import { servedRoles } from "@/session/store";
import { LoadingScreen } from "@/shell/LoadingScreen";

export default function SignedInLayout() {
  const session = useSession();
  const platform = usePlatform();
  if (session.status === "restoring") return <LoadingScreen />;
  if (session.status === "signedOut") return <Redirect href="/welcome" />;
  const served = servedRoles(session.roles);
  const dual =
    platform === "web" &&
    served.includes("PARENT") &&
    served.includes("SCHOOL_ADMIN") &&
    session.schoolAdminSchools.length > 0;
  if (!dual) {
    const href = landingHref(resolveLanding(session, platform)) ?? "/";
    return <Redirect href={href as Href} />;
  }
  return <Slot />;
}

// A screen that throws shows the themed fallback.
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
